<template>
    <div class="ModalLayout" :class="{ collapsed, keepHeader }">
        <div ref="headerContainer" class="headerContainer">
            <slot name="header" />
            <div v-if="$slots.header" class="headerDivider" />
        </div>
        <div class="collapsedContentAnchor">
            <div ref="collapsedContentContainer" class="collapsedContentContainer">
                <slot name="collapsedContent" />
            </div>
        </div>
        <div ref="contentContainer" class="contentContainer" :class="{ hasScroll }">
            <slot name="content" />
        </div>
        <div ref="scrollIndicator" class="scrollIndicator">
            <div class="scrollIndicatorHandle" />
        </div>
        <div class="scrollFadeAnchor">
            <div v-if="hasScroll" class="scrollFade" />
        </div>
        <div class="footerContainer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';

export default {
    props: {
        collapsed: {
            type: Boolean,
            default: true
        },
        keepHeader: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.hasScroll = false;
    },
    mounted() {
        this.hasScroll = this.$refs.contentContainer.scrollHeight > this.$refs.contentContainer.clientHeight;
        if (this.hasScroll) {
            this.$refs.contentContainer.addEventListener('scroll', this.handleScroll);
            EventBus.$on('resize-end', this.handleResize);
            this.handleResize();
        }
    },
    beforeDestroy() {
        if (this.hasScroll) {
            this.$refs.contentContainer.removeEventListener('scroll', this.handleScroll);
            EventBus.$off('resize-end', this.handleResize);
        }
    },
    methods: {
        getCollapsedHeight() {
            return (
                this.$refs.collapsedContentContainer.clientHeight +
                (this.keepHeader ? this.$refs.headerContainer.clientHeight : 0)
            );
        },
        handleResize() {
            const el = this.$refs.contentContainer;
            const scrollHeight = el.scrollHeight;
            const clientHeight = el.clientHeight;
            const scrollIndicator = this.$refs.scrollIndicator;
            scrollIndicator.style.top = `calc(${el.offsetTop}px + 1em)`;
            scrollIndicator.firstElementChild.style.height = (clientHeight / scrollHeight) * 100 + '%';
        },
        handleScroll() {
            const el = this.$refs.contentContainer;
            const scrollTop = el.scrollTop;
            const scrollHeight = el.scrollHeight;
            const scrollIndicator = this.$refs.scrollIndicator;
            scrollIndicator.style.transform = `translateY(${
                (scrollTop * scrollIndicator.clientHeight) / scrollHeight
            }px)`;
        }
    }
};
</script>

<style lang="scss" scoped>
.ModalLayout {
    position: relative;
    background-color: white;
    color: black;
    border-radius: 1em;
    color: black;
    display: flex;
    flex-direction: column;

    &.collapsed {
        .scrollIndicator {
            opacity: 0;
        }
    }
    &.collapsed:not(.keepHeader) {
        .headerContainer {
            visibility: hidden;
        }
        .collapsedContentAnchor {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
        }
    }
    &:not(.collapsed) {
        .collapsedContentContainer {
            visibility: hidden;
        }
    }
}

.collapsedContentAnchor {
    z-index: 1;
}

.headerDivider {
    height: 1px;
    background-color: mix(white, black, 95%);
}

.collapsedContentContainer {
    position: absolute;
    left: 0;
    right: 0;
    background-color: white;
    border-radius: 1em;
}
.contentContainer {
    flex: 1;
    overflow-y: auto;
    position: relative;
}
.footerContainer {
    flex-shrink: 0;
    &:not(:empty) {
        border-top: 1px solid mix(white, black, 95%);
    }
}

.contentContainer.hasScroll {
    padding-bottom: 1em;
}
.scrollIndicator {
    position: absolute;
    top: 1em;
    bottom: 1em;
    right: 4px;
    transform-origin: top center;
    opacity: 1;
    transition: opacity 1s;
}
.scrollIndicatorHandle {
    width: 4px;
    background-color: #868dd0;
    border-radius: 4px;
}

.scrollFadeAnchor {
    position: relative;
    height: 0;
}
.scrollFade {
    height: 2em;
    position: absolute;
    left: 1em;
    bottom: 0;
    right: 1em;
    pointer-events: none;
    background: linear-gradient(transparent, white);
}
</style>
